import { useMainPageHostList } from '@/features/recommendation-management/main-page/$store-list/$host-list/hooks/useMainPageHostList';
import { HostListTable } from '@/features/recommendation-management/main-page/$store-list/$host-list/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['hostName', 'createdDate', 'updatedDate']),
  desc: z.boolean(),
});

const MainPageHostSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),
  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),
  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
  locationId: z.string().catch(''),
  displayOrderId: z.string().catch(''),
  recommendationId: z.string().catch(''),
});

export const Route = createFileRoute('/(app)/recommendation-management/main-page/$store-list/$host-list/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => MainPageHostSearchSchema.parse(search),
});

function RouteComponent() {
  const { mainPageHost, pagination, isLoading } = useMainPageHostList();
  return <HostListTable data={mainPageHost} pagination={pagination} loading={isLoading} />;
}
